import { render, staticRenderFns } from "./MySales.vue?vue&type=template&id=3523efa1"
import script from "./MySales.vue?vue&type=script&lang=js"
export * from "./MySales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports